import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import { useA11ySelector } from '@sg/a11y-helpers';

import { SavedPaymentMethods } from '@order/features-payments';

import { AccountScreenContainer, AccountScreenTitle, SignedOutView } from '../../components';
import { useIsLoggedIn } from '../../context/AuthMachine';

// ─────────────────────────────────────────────────────────────────────────────

export const PaymentsScreen = () => {
  const { formatMessage } = useIntl();
  const title = formatMessage(messages.title);
  const containerA11ySelector = useA11ySelector('account.payments.container');

  // ─── Flags ───────────────────────────────────────────────────────────

  const isLoggedIn = useIsLoggedIn();

  // ─────────────────────────────────────────────────────────────────────

  if (!isLoggedIn) {
    return <SignedOutView redirectTo="/account/payments" withoutFooter />;
  }

  return (
    <AccountScreenContainer screen="payments" {...containerA11ySelector.props}>
      <AccountScreenTitle title={title} />

      <SavedPaymentMethods />
    </AccountScreenContainer>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  title: {
    defaultMessage: 'Payment methods',
    description: 'Payments Screen | Title',
  },
});
